import { render } from "./BloodPressure.vue?vue&type=template&id=1fa5e1c1"
import script from "./BloodPressure.vue?vue&type=script&lang=js"
export * from "./BloodPressure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__